import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function AboutPage() {
  const [lightboxOpen, setLightboxOpen] = useState(false);

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Güvenilirlik',
      description: '10+ yıllık deneyimimiz ve %98 başarı oranımızla güvenilir hizmet sunuyoruz',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Müşteri Odaklılık',
      description: 'Her müşterimize özel çözümler üretiyor, süreç boyunca yanınızda oluyoruz',
    },
    {
      icon: 'ri-time-line',
      title: 'Hızlı Hizmet',
      description: 'Aynı gün randevu ve hızlı evrak hazırlığı ile zamanınızı değerli tutuyoruz',
    },
    {
      icon: 'ri-award-line',
      title: 'Profesyonellik',
      description: 'Uzman kadromuz ile en güncel vize prosedürlerini takip ediyoruz',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary/10 via-lightBlue to-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="font-heading font-bold text-4xl lg:text-5xl text-darkBlue mb-6">
              İzmir Vize Danışmanlık Hakkında
            </h1>
            <p className="font-body text-lg text-gray-600 leading-relaxed">
              2014 yılından bu yana İzmir'de vize danışmanlığı alanında hizmet veren firmamız, binlerce kişinin hayallerindeki ülkelere ulaşmasına yardımcı oldu. Konak merkezli ofisimizle İzmir vize başvurusu süreçlerinizde yanınızdayız.
            </p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div
                className="relative group cursor-pointer overflow-hidden rounded-2xl shadow-xl"
                onClick={() => setLightboxOpen(true)}
              >
                <img
                  src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/605cef5ec2fabd892caa879657e71fe8.png"
                  alt="İzmir Vize Danışmanlık Ofisi"
                  className="w-full h-[400px] object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/80 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300 transform scale-75 group-hover:scale-100">
                    <i className="ri-zoom-in-line text-darkBlue text-2xl"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-6">
              <h2 className="font-heading font-bold text-3xl text-darkBlue">
                İzmir'in En Güvenilir Vize Danışmanlık Merkezi
              </h2>
              <p className="font-body text-gray-600 leading-relaxed">
                <strong className="text-darkBlue">İzmir Vize Danışmanlık</strong> olarak, Schengen vizesi, Amerika vizesi, İngiltere vizesi ve 50'den fazla ülkeye vize başvuru süreçlerinde profesyonel destek sağlıyoruz. Konak'taki merkezi ofisimizden İzmir'in her noktasına kolayca ulaşabilirsiniz.
              </p>
              <p className="font-body text-gray-600 leading-relaxed">
                Uzman kadromuz, sürekli güncellenen vize prosedürlerini yakından takip ederek müşterilerimize en doğru ve güncel bilgileri sunmaktadır. İzmir Schengen vizesi, İzmir Amerika vizesi ve İzmir İngiltere vizesi başvurularında %98 başarı oranımızla sektörde öncü konumdayız.
              </p>
              <p className="font-body text-gray-600 leading-relaxed">
                2500'den fazla başarılı vize başvurusu ile müşterilerimizin güvenini kazandık. Her başvuruyu özenle değerlendiriyor, eksiklikleri tespit ediyor ve en uygun çözümleri sunuyoruz.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-lightBlue">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-heading font-bold text-3xl lg:text-4xl text-darkBlue mb-4">
              Değerlerimiz
            </h2>
            <p className="font-body text-lg text-gray-600 max-w-2xl mx-auto">
              İzmir vize danışmanlık hizmetlerimizde bizi öne çıkaran değerler
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 text-center"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${value.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="font-heading font-bold text-xl text-darkBlue mb-3">{value.title}</h3>
                <p className="font-body text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-heading font-bold text-3xl lg:text-4xl text-darkBlue mb-4">
              Neden İzmir Vize Danışmanlık?
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-secondary text-2xl"></i>
              </div>
              <div>
                <h3 className="font-heading font-bold text-xl text-darkBlue mb-2">
                  10+ Yıllık Deneyim
                </h3>
                <p className="font-body text-gray-600">
                  2014'ten bu yana İzmir'de vize danışmanlığı yapıyoruz. Binlerce başarılı vize başvurusu deneyimimiz var.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-secondary text-2xl"></i>
              </div>
              <div>
                <h3 className="font-heading font-bold text-xl text-darkBlue mb-2">
                  %98 Başarı Oranı
                </h3>
                <p className="font-body text-gray-600">
                  Profesyonel yaklaşımımız ve detaylı evrak hazırlığımız sayesinde %98 başarı oranına ulaştık.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-secondary text-2xl"></i>
              </div>
              <div>
                <h3 className="font-heading font-bold text-xl text-darkBlue mb-2">
                  Merkezi Konum
                </h3>
                <p className="font-body text-gray-600">
                  Konak'taki ofisimiz sayesinde İzmir'in her yerinden kolayca ulaşabilirsiniz. Toplu taşıma bağlantıları çok yakın.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-secondary text-2xl"></i>
              </div>
              <div>
                <h3 className="font-heading font-bold text-xl text-darkBlue mb-2">
                  Ücretsiz Ön Değerlendirme
                </h3>
                <p className="font-body text-gray-600">
                  Vize başvurunuz için ücretsiz ön değerlendirme yapıyor, size en uygun çözümü sunuyoruz.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-secondary text-2xl"></i>
              </div>
              <div>
                <h3 className="font-heading font-bold text-xl text-darkBlue mb-2">
                  Aynı Gün Randevu
                </h3>
                <p className="font-body text-gray-600">
                  Acil durumlarınızda aynı gün randevu imkanı sunuyoruz. Hızlı ve etkili çözümler üretiyoruz.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-secondary text-2xl"></i>
              </div>
              <div>
                <h3 className="font-heading font-bold text-xl text-darkBlue mb-2">
                  Süreç Takibi
                </h3>
                <p className="font-body text-gray-600">
                  Başvurunuzun her aşamasını takip ediyor, sizi sürekli bilgilendiriyoruz. Şeffaf hizmet anlayışımız var.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-secondary to-orange-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading font-bold text-3xl lg:text-4xl text-white mb-4">
            Vize Başvurunuz İçin Hemen İletişime Geçin
          </h2>
          <p className="font-body text-lg text-white/90 mb-8">
            Ücretsiz ön değerlendirme için ofisimizi ziyaret edin veya bizi arayın
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/iletisim"
              className="bg-white hover:bg-gray-100 text-secondary px-8 py-4 rounded-full font-body font-bold transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              İletişime Geç
            </Link>
            <a
              href="tel:+905422671171"
              className="bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white border-2 border-white px-8 py-4 rounded-full font-body font-bold transition-all whitespace-nowrap"
            >
              +90 542 267 11 71
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
          onClick={() => setLightboxOpen(false)}
        >
          <button
            onClick={() => setLightboxOpen(false)}
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/40 rounded-full transition-all cursor-pointer"
          >
            <i className="ri-close-line text-white text-2xl"></i>
          </button>
          <img
            src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/605cef5ec2fabd892caa879657e71fe8.png"
            alt="İzmir Vize Danışmanlık Ofisi"
            className="max-w-full max-h-[90vh] rounded-xl object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
